import { render, staticRenderFns } from "./PaperProve.vue?vue&type=template&id=53081446&scoped=true&"
import script from "./PaperProve.vue?vue&type=script&lang=js&"
export * from "./PaperProve.vue?vue&type=script&lang=js&"
import style0 from "./PaperProve.vue?vue&type=style&index=0&id=53081446&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53081446",
  null
  
)

export default component.exports